<template>
  <div class="service_drop_menu">
    <div class="scroll_wrap">
      <div class="row_wrap">
        <div class="col_group is_m_show">
          <router-link-ex :to="`${countryPath}/marketplace`" class="service_title">{{ $t('service.show-all') }}</router-link-ex>
        </div>

          <market-place-menu-item v-if="hasChannelingServices" :column="column" :mode="mode" v-for="(column, colIdx) in isMobile ? this.swapRowColWithMaxCol(marketPlaceGnbHierarchy.channelingServices, 5) : marketPlaceGnbHierarchy.channelingServices" :key="colIdx" />

      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { namespace, types } from '../../store/modules/marketplace-hierarchy-store'
import MarketPlaceMenuItem from './MarketPlaceMenuItem'

export default {
  data() {
    return {
      mode: mode
    }
  },
  created() {
    this.getMarketPlaceGnbHierarchy()
  },
  methods: {
    ...mapActions(namespace, [types.GET_MARKETPLACE_GNB_HIERARCHY])
  },
  computed: {
    ...mapState(namespace, ['marketPlaceGnbHierarchy']),
    hasChannelingServices() {
      return !!this.marketPlaceGnbHierarchy.channelingServices && this.marketPlaceGnbHierarchy.channelingServices.length > 0
    }
  },
  components: { MarketPlaceMenuItem }
}
</script>
